import { createContext, useContext, useState } from 'react';

const PaymentContext = createContext();

export function PaymentProvider({ children }) {
  const [paymentStatus, setPaymentStatus] = useState('');
  const [subscriptionId, setSubscriptionId] = useState('');

  return (
    <PaymentContext.Provider
      value={{
        paymentStatus,
        setPaymentStatus,
        subscriptionId,
        setSubscriptionId,
      }}
    >
      {children}
    </PaymentContext.Provider>
  );
}

export function usePayment() {
  return useContext(PaymentContext);
}
